var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVimeo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 58,
    viewBox: "0 0 59 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9456 14.4468L6.89966 19.927L8.99159 22.561C9.9232 21.9819 11.7864 20.4712 12.6173 20.4712C14.4805 20.4712 16.1555 25.5196 17.7537 31.0714C19.1889 36.0567 20.6744 48.4446 27.523 48.4446C35.4039 48.4446 51.9714 27.1687 51.9714 17.6995C51.9714 14.2732 51.2916 9.34229 44.4682 9.34229C37.1563 9.34229 33.559 16.3987 32.6744 19.927C33.3108 19.5027 35.0432 19.2198 35.9978 19.2198C39.887 19.2198 39.0564 23.2511 38.526 24.8775C37.9957 26.5038 33.9184 34.423 31.7197 34.423C29.0327 34.423 27.4416 22.7554 26.6638 17.6995C25.886 12.6436 23.8707 9.88579 20.7947 9.88579C18.3339 9.88579 14.5366 12.9264 12.9456 14.4468Z",
    fill: "#3CB9E6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVimeo);
export default __webpack_public_path__ + "static/media/vimeo.0502a2b2c0ebda11b237709b57c2af73.svg";
export { ForwardRef as ReactComponent };